import http from "../http";

export const getCategories = (storeId) => {
  return http.get(`/store-management/categories/?store_id=${storeId}`);
};

export const createCategory = (storeId, data) => {
  return http.post(`/store-management/categories/?store_id=${storeId}`, data);
};

export const deleteCategory = (storeId, id) => {
  return http.delete(`/store-management/categories/${id}/?store_id=${storeId}`);
};

export const updateCategory = (storeId, categoryId, payload) =>
  http.patch(
    `/store-management/categories/${categoryId}/?store_id=${storeId}`,
    payload,
  );
